module.exports = __webpack_public_path__ + "img/bm.42614713.svg";